import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import DropdownButton from "app/components/DropdownButton";
import CheckBox from "app/components/inputs/CheckBox";
import { TagSortOrder } from "../Tags.types";
import styles from "./styles.module.scss";

interface Props {
  value: TagSortOrder;
  onChange: (order: TagSortOrder) => void;
}

const TagsFilter = ({ value, onChange }: Props) => {
  const { t } = useTranslation();

  // DropdownButton owns its open state; bumping `closeModal` is the only hook it
  // exposes for closing the panel from outside.
  const [closeSignal, setCloseSignal] = useState(0);

  const options: { value: TagSortOrder; label: string }[] = [
    { value: "asc", label: t("A to Z") },
    { value: "desc", label: t("Z to A") },
  ];

  const selectOrder = (order: TagSortOrder) => {
    if (order !== value) {
      onChange(order);
    }
    setCloseSignal((previous) => previous + 1);
  };

  return (
    <DropdownButton
      hideButtonStyles
      closeModal={closeSignal}
      dropdownClassname={styles.container}
      btnClassName={styles.filter_btn}
      dropdownWrapperClass={styles.dropdown_container}
      btnContent={
        // Just the label. CFTB-3428 made DropdownButton's own trigger the
        // button — focusable, announced, and opened with Enter or Space — so a
        // second role="button" in here would be a button inside a button and a
        // second tab stop for the one control.
        <span className={styles.filter_btn_content}>
          <i className="ico ico-funnel" />
          <p>{t("Filter")}</p>
        </span>
      }
    >
      <div className={styles.dropdown_list}>
        <span className={styles.group_label}>{t("Sort by")}</span>
        {options.map((option) => (
          <CheckBox
            key={option.value}
            className={styles.option}
            name="tags-sort-order"
            label={option.label}
            checked={option.value === value}
            onChange={() => selectOrder(option.value)}
          />
        ))}
      </div>
    </DropdownButton>
  );
};

export default TagsFilter;
